import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AccessPointFilterActvityComponent } from 'src/app/shared-layout/Components/activity/access-point-filter-actvity/access-point-filter-actvity.component';
import { IFilterCriteria } from 'src/app/shared-layout/header/account-settings/account-setting-interfaces';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { CommonService } from 'src/app/shared/utils/common.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { convertDateTimeFormat } from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import {
  IUserActivity,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from 'src/app/shared/state-management/state-interfaces';
import {
  updateUserActivities,
  clearUserActivities,
} from '../../../shared/state-management/actions';
import {
  Activities,
  IActivityEvents,
} from 'src/app/shared-layout/Components/activity/activity.interface';

@Component({
  selector: 'app-user-profile-activity',
  templateUrl: './user-profile-activity.component.html',
  styleUrls: ['./user-profile-activity.component.scss'],
})
export class UserProfileActivityComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() profileDetails!: IUserProfile;
  @Input() userActivities!: Activities;
  @Input() userDetailsFormGroupName!: string;
  @Input() selectedActivity!: IUserActivity;
  @Output() selectedActivityChange = new EventEmitter<IUserActivity>();
  @Output() getMyLastActivity = new EventEmitter<IFilterCriteria>();
  @Input() ownProfile!: boolean;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  previousUserEmail: string | undefined;
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  userAccessformGroup!: FormGroup;
  filterActivity: any;
  filterCount: number = 0;
  filterCriteria: IFilterCriteria = {
    pagination: {
      size: 20,
      cursor: null,
    },
  };
  sharedData?: ISharedData;
  commonAccessControl!: boolean;
  isFetching: boolean = false;
  userEvents: IActivityEvents[] = [];
  cursor: any = null;
  totalRecords: number = 0;
  hasMoreData: boolean = true;
  isInitialLoad: boolean = true;
  loadingMore: boolean = false;
  expandedActivityId: string | null = null;

  // Event codes that should display description text
  private readonly DESCRIPTION_EVENT_CODES = [
    '0x07',
    '0x08',
    '0x09',
    '0x1c',
    '0x1d',
  ];

  constructor(
    private rootFormGroup: FormGroupDirective,
    private helperService: HelperService,
    private stateManagementService: StateManagementService,
    private commonService: CommonService,
    private accountSettingService: AccountSettingsService,
    private ngRedux: NgRedux<IAppState>,
    private translate: TranslateService
  ) {
    this.ngRedux.select('userActivities').subscribe((userActivities: any) => {
      if (
        JSON.stringify(this.userEvents) !==
        JSON.stringify(userActivities.events)
      ) {
        if (userActivities?.events) {
          this.userEvents = userActivities.events || [];
          this.userActivities = userActivities;
          this.totalRecords = userActivities.totalRecords || 0;
          this.filterCriteria.pagination.cursor = userActivities.cursor;
          this.hasMoreData = this.userEvents.length < this.totalRecords;
          this.synchronizeUserEvents();
        }
      }
    });
  }

  ngAfterViewInit() {
    if (this.isInitialLoad && this.profileDetails?.email) {
      this.isInitialLoad = false;
      this.loadUserActivities();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileDetails']) {
      const currentEmail = changes['profileDetails'].currentValue?.email;
      const previousEmail = this.previousUserEmail;

      if (currentEmail && previousEmail !== currentEmail) {
        this.resetComponent();
        this.ngRedux.dispatch(clearUserActivities());
        this.isInitialLoad = true;
        this.loadUserActivities();
      }

      this.previousUserEmail = currentEmail;
    }
  }

  ngOnInit(): void {
    this.commonAccessControl =
      this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    this.initializeFilter();
    this.userAccessformGroup = this.rootFormGroup.control.get(
      this.userDetailsFormGroupName
    ) as FormGroup;
    this.resetComponent();
    this.ngRedux.dispatch(clearUserActivities());
  }

  resetComponent(): void {
    // this.filterCount = 0;
    this.resetVariables();
    this.ngRedux.dispatch(clearUserActivities());
  }

  resetVariables() {
    this.userEvents = [];
    this.cursor = null;
    this.totalRecords = 0;
    this.hasMoreData = true;
    this.isFetching = false;
    this.loadingMore = false;

    this.userActivities = { events: [], totalRecords: 0 };
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.initializeFilter();
    if (this.ownProfile) {
      this.commonService.setOwnProfile(this.ownProfile);
    }
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description add new control for form control
   * @param controlName control name for creation
   * @returns void
   */
  addNewControl(controlName: string, required = false): void {
    let dCtrl = new FormControl();
    if (required) {
      dCtrl.setValidators(MFValidators.required);
    }
    this.userAccessformGroup.addControl(controlName, dCtrl);
    dCtrl.updateValueAndValidity();
  }

  /**
   * @description #initializeFilter function gets the floorList from app and
   *               map the data int the required state of filter component.
   * @returns void
   */
  initializeFilter(): void {
    this.filterActivity = {
      users: '',
      dates: '',
      lockType: [],
      lockIds: [],
    };

    this.filterCriteria = {
      pagination: {
        size: 20,
      },
    };
  }

  /**
   * @description open modal and show filter activity
   * @returns void
   */
  onFilterActivity(): void {
    const dialogInstance = this.helperService.openModalDialog(
      AccessPointFilterActvityComponent,
      { ...this.filterActivity, isProfileActivityFilter: true },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((filter: any) => {
      if (filter) {
        this.filterActivity = filter;

        this.filterCriteria = {
          pagination: {
            size: 20,
            cursor: null,
          },
        };

        if (filter?.dates?.start && filter?.dates?.end) {
          this.filterCriteria.dateFrom = convertDateTimeFormat(
            filter?.dates?.start,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
          this.filterCriteria.dateTo = convertDateTimeFormat(
            filter?.dates?.end,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
        }

        this.filterCriteria.eventCode = filter?.lockIds;
        this.resetComponent();
        const dateCount = this.filterActivity?.dates ? 1 : 0;
        this.filterCount =
          (this.filterActivity?.lockType?.length || 0) + dateCount;
        this.getProfileActivityWithFilter(this.filterCriteria);
      }
    });
  }

  getProfileActivityWithFilter(filterCriteria: any): any {
    this.getMyLastActivity?.emit(filterCriteria);
    this.loadUserActivities();
  }

  /**
   * @description Handler for infinite scroll event
   * This is triggered by ngx-infinite-scroll directive
   */
  onScrollDown(): void {
    if (!this.isFetching && this.hasMoreData) {
      this.loadingMore = true;
      this.loadUserActivities();
    }
  }

  /**
   * Function used as the trackBy function for ngFor directive.
   * It tracks the options in the ngFor loop based on the provided index and option.
   *
   * @param index The index of the current option in the ngFor loop.
   * @param option The current option object in the ngFor loop.
   * @returns The option itself as the unique identifier for tracking.
   */
  trackByOption(index: number, option: any) {
    return option?.id || index;
  }

  /**
   * Determines the severity class based on event properties.
   */
  getSeverityClass(event: IActivityEvents): string {
    const eventCode = (event.eventCode || '').toLowerCase();
    const alertCodes = CONSTANTS.ALERT_DEVICE_EVENT_CODE;
    const unlockCodes = CONSTANTS.UNLOCK_DEVICE_EVENT_CODE;
    const lockedCodes = CONSTANTS.LOCKED_UNIT_EVENT_CODE;
    const onlineCodes = CONSTANTS.ONLINE_DEVICE_EVENT_CODE;

    if (
      event.isIssue === true ||
      event.isAbnormal === true ||
      alertCodes.includes(eventCode)
    ) {
      return 'severity-critical';
    } else if (unlockCodes.includes(eventCode)) {
      return 'severity-success';
    } else if (lockedCodes.includes(eventCode)) {
      return 'severity-warning';
    } else if (onlineCodes.includes(eventCode)) {
      return 'severity-info';
    }

    return 'severity-warning';
  }

  /**
   * Gets the icon path based on event code.
   */
  getEventIcon(event: IActivityEvents): string {
    const eventCode = (event.eventCode || '').toLowerCase();
    const alertCodes = CONSTANTS.ALERT_DEVICE_EVENT_CODE;
    const unlockCodes = CONSTANTS.UNLOCK_DEVICE_EVENT_CODE;
    const lockedCodes = CONSTANTS.LOCKED_UNIT_EVENT_CODE;
    const onlineCodes = CONSTANTS.ONLINE_DEVICE_EVENT_CODE;

    if (
      event.isIssue === true ||
      event.isAbnormal === true ||
      alertCodes.includes(eventCode)
    ) {
      return 'assets/svg/' + CONSTANTS.ALERT_ICON;
    } else if (unlockCodes.includes(eventCode)) {
      return 'assets/svg/' + CONSTANTS.UNLOCK_EVENT_ICON;
    } else if (lockedCodes.includes(eventCode)) {
      return 'assets/svg/' + CONSTANTS.LOCK_ICON;
    } else if (onlineCodes.includes(eventCode)) {
      return 'assets/svg/' + CONSTANTS.ONLINE_ICON;
    }

    return 'assets/svg/' + CONSTANTS.LOCK_ICON;
  }

  /**
   * Gets the source display string for an event.
   */
  getSourceDisplay(event: IActivityEvents): string {
    const source = event.source || '';
    const sourceName = event.sourceName?.trim();

    if (sourceName) {
      if (source.toUpperCase() !== 'NFC') {
        return `${source} | ${sourceName}`;
      }

      const [badgeIdPart = '', cardNamePart = ''] = sourceName
        .split('|')
        .map((part) => part.trim());
      const rawCardName = cardNamePart || sourceName;
      const cardName = event.isMaster
        ? `${this.translate.instant('MASTER')} ${rawCardName}`
        : rawCardName;
      const badgeId = badgeIdPart || '';

      return badgeId
        ? `${source} | ${cardName} - ID.${badgeId}`
        : `${source} | ${cardName}`;
    }
    return source;
  }

  /**
   * Checks if extraDescription should be shown for this event.
   */
  hasExtraDescription(event: IActivityEvents): boolean {
    const eventCode = (event.eventCode || '').toLowerCase();
    return (
      this.DESCRIPTION_EVENT_CODES.includes(eventCode) ||
      event.isIssue === true ||
      event.isAbnormal === true
    );
  }

  /**
   * Toggles the dropdown for an activity.
   */
  toggleDropdown(activityId: string): void {
    if (this.expandedActivityId === activityId) {
      this.expandedActivityId = null;
    } else {
      this.expandedActivityId = activityId;
    }
  }

  private synchronizeUserEvents(): void {
    if (this.userActivities && this.userActivities.events) {
      // Ensure both are synchronized
      this.userEvents = [...this.userActivities.events];

      if (this.userEvents.length > this.totalRecords) {
        console.warn(
          `userEvents length (${this.userEvents.length}) exceeds totalRecords (${this.totalRecords}). Truncating.`
        );
        this.userEvents = this.userEvents.slice(0, this.totalRecords);
      }

      this.hasMoreData = this.userEvents.length < this.totalRecords;
    }
  }

  private addUniqueActivities(newActivities: IActivityEvents[]): void {
    if (!this.userActivities) {
      this.userActivities = { events: [], totalRecords: 0 };
    }

    if (!this.userActivities.events) {
      this.userActivities.events = [];
    }

    const existingIds = new Set(
      this.userActivities.events.map((event) => event.id)
    );

    const uniqueActivities = newActivities.filter(
      (activity) => !existingIds.has(activity.id)
    );

    this.userActivities.events.push(...uniqueActivities);
    this.hasMoreData =
      this.userActivities.events.length <
      (this.userActivities.totalRecords || 0);
  }

  loadUserActivities(): void {
    if (this.isFetching) return;

    this.isFetching = true;
    const siteId =
      this.stateManagementService.getSharedData()?.selectedSite?.siteId;
    if (!siteId) {
      this.isFetching = false;
      return;
    }

    this.accountSettingService
      .getEventHistoryByUserNew(
        this.profileDetails.email!,
        this.filterCriteria,
        siteId?.toString()!
      )
      .subscribe(
        (res: any) => {
          if (res?.events) {
            if (this.userActivities) {
              this.userActivities.totalRecords = res.totalRecords;
            }

            this.addUniqueActivities(res.events);
            this.ngRedux.dispatch(updateUserActivities(this.userActivities));

            if (res.cursor) {
              this.filterCriteria.pagination.cursor = res.cursor;
            }

            this.hasMoreData = res.events.length > 0 && res.cursor !== null;
          } else {
            this.hasMoreData = false;
          }

          this.isFetching = false;
          this.loadingMore = false;
        },
        (error: any) => {
          this.isFetching = false;
          this.loadingMore = false;
          this.hasMoreData = false;
        }
      );
  }
}
